import React from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { GetTypographyContent } from "../shared/Typography/Typography";
import { CreateAccountCenterContainerPaddedTop } from "../CreateAccount/CreateAccountForm.styles";
import { VERIFY_EMAIL_SEND_AGAIN_URL } from "../../utils/urlConstants";
import { getUserAuth } from "../../recoil/selectors";

export const VerifyEmailSection = (): React.ReactElement => {
  const { t } = useTranslation();
  const authInfo = useRecoilValue(getUserAuth);
  return (
    <CreateAccountCenterContainerPaddedTop>
      {GetTypographyContent({
        content: t("verifyEmail.title"),
        size: "h3",
        isBold: true,
        textColor: "neutral700",
      })}
      {GetTypographyContent({
        content: t("verifyEmail.sentTo"),
        size: "medium",
        textColor: "neutral700",
        padding: "24px 0 0 0",
      })}
      {GetTypographyContent({
        content: authInfo?.email as string,
        size: "medium",
        isBold: true,
        textColor: "greenDark",
      })}
      {GetTypographyContent({
        content: t("verifyEmail.activatePrompt"),
        size: "medium",
        textColor: "neutral700",
        padding: "24px 0 0 0",
      })}
      {GetTypographyContent({
        content: t("verifyEmail.didNotReceive"),
        size: "small",
        textColor: "greenDark",
        padding: "24px 0 0 0",
        link: VERIFY_EMAIL_SEND_AGAIN_URL,
      })}
    </CreateAccountCenterContainerPaddedTop>
  );
};
